import { transformData } from '@crehana/utils';

import {
  GetUserEnrollmentsQuery,
  GetUserEnrollmentsQuery_content_enrollments_user_enrollments_edges_node,
} from '../../graphql/types/GetUserEnrollmentsQuery';
import { TUserEnrollment } from './types';

export const parseCourseEnrollment = (
  node: GetUserEnrollmentsQuery_content_enrollments_user_enrollments_edges_node,
): TUserEnrollment => {
  const { course, progress, is_hidden } = node;
  const dashboardUrl = `/clases/v2/${course?.id}`;
  const dashboardDetailUrl = `${dashboardUrl}/detalle/`;
  const dashboardProjectViewUrl = `${dashboardUrl}/proyecto/`;
  const dashboardProjecCreatetUrl = `${dashboardUrl}/proyecto/crear/`;
  const playerUrl = `${dashboardUrl}/player/`;

  return {
    ...node,
    progress: progress || 0,
    dashboardDetailUrl,
    dashboardProjectViewUrl,
    dashboardProjecCreatetUrl,
    playerUrl,
    isHidden: is_hidden || false,
    isMandatory: course?.is_mandatory || false,
    isCertificationAvailable: Boolean(
      course?.has_certification_available ?? true,
    ),
  };
};

export const parseCourseEnrollmentsQuery = (
  data?: GetUserEnrollmentsQuery,
): TUserEnrollment[] => {
  const dataTransform = transformData(
    data?.content_enrollments?.user_enrollments,
  );

  return dataTransform.map(parseCourseEnrollment);
};
